import type {
  ConfigurationMapField,
  ConfigurationMapHook,
} from '@rossum/api-client/internal';

/** Node type — schema field type for fields, 'rule' for rules, hookType for hooks. */
export type SearchOptionType =
  | ConfigurationMapField['type']
  | 'rule'
  | ConfigurationMapHook['hookType'];

export type SearchOption = {
  /** Unique node ID (field ID, rule ID, hook ID). */
  id: string;
  /** Display name (= id for fields, name for rules/hooks). */
  label: string;
  /** Node type — schema field type for fields, 'rule' / hookType for rules/hooks. */
  type: SearchOptionType;
};

const optionGroupMap: Record<SearchOptionType, 'field' | 'rule' | 'hook'> = {
  rule: 'rule',
  function: 'hook',
  webhook: 'hook',
  captured: 'field',
  data: 'field',
  external: 'field',
  formula: 'field',
  lookup: 'field',
  manual: 'field',
  reasoning: 'field',
};

export const getOptionGroup = (
  type: SearchOptionType
): 'field' | 'rule' | 'hook' => optionGroupMap[type];
